import * as GroupsSelectors from './groups';
import * as CollaboratorsSelectors from './collaborators';
import * as CurrentsSelectors from './current';
import * as SettingsSelectors from './settings';

export const isCollaborationDataReady = (state) =>
    GroupsSelectors.isGroupsDataExist(state) &&
    CollaboratorsSelectors.isCollaboratorsDataExist(state) &&
    !!CurrentsSelectors.getCurrentGroupId(state) &&
    !!CurrentsSelectors.getCurrentCollaboratorId(state);

export const isSellerGroupInPreRevisionMode = (state) =>
    !GroupsSelectors.isExternalCollaborationTabSelected(state) &&
    SettingsSelectors.isPreRevisionBehavior(state);

export const isSellerGroupInRevisionMode = (state) =>
    !GroupsSelectors.isExternalCollaborationTabSelected(state) &&
    SettingsSelectors.isRevisionBehavior(state);

export const isSellerGroupInPostRevisionMode = (state) =>
    !GroupsSelectors.isExternalCollaborationTabSelected(state) &&
    SettingsSelectors.isPostRevisionBehavior(state);
